<script>
import ModelEdit from '../models/edit';
import FormsModel from "@/components/forms/jala-cycle";

export default {
  extends: ModelEdit,
  page: {
    title: "Edit JALA Cycles",
  },
  props: {
    cardTitle: {default() { return this.lodash.startCase(this.$t('jala_cycles.singular')) }},
    resourceRoute: {default: 'jala_cycles'},
    modelVariable: {default: 'jala_cycle'},
    form: {default() { return FormsModel; }}
  },
  data() {
    return {
      title: this.lodash.upperFirst(this.$t('jala_cycles.plural'))
    }
  },
  mounted() {
    this.fetchModel();
  },
  computed: {
    items() {
      return [
        {
          text: this.lodash.upperFirst(this.$t('jala_cycles.plural')),
          href: "/jala_cycles",
        },
        {
          text: this.model && this.model.id ? this.model['name'] : this.$route.params.key,
          href: `/jala_cycles/${this.$route.params.key}`,
          active: true,
        },
        {
          text: this.$t('Edit'),
          href: `/jala_cycles/${this.$route.params.key}/edit`,
          active: true,
        },
      ]
    }
  },
  methods: {
    fetchModel() {
      this.loading = true;
      this.$axios.get(`/jala/cycles/${this.$route.params.key}`).then((response) => {
        const { data: { data } } = response;
        this.model = data;
        return response;
      }).catch((error) => this.failedAlert(error))
      .finally(() => this.loading = false)
    },
    update(value) {
      return this.$axios.put(`/jala/cycles/${this.$route.params.key}`, value)
    },
    delete() {
      return this.$axios.delete(`/jala/cycles/${this.$route.params.key}`)
    }
  }
}
</script>
